(() => {
  angular
    .module('gm.common.directives')
    .directive('gmWatchChange', gmWatchChangeDirective);

  function gmWatchChangeDirective(
    $parse
  ) {
    'ngInject';

    return {
      link(_scope, element, attrs) {
        const fn = $parse(attrs.gmWatchChange);
        element.on('input', (e) => {
          fn(e);
        });
      }
    };
  }
})();
